var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJeans(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.401 25.431l3.527 1.118c.057.03.114.03.173.03.114 0 .2-.03.315-.087a.555.555 0 00.258-.401l1.49-10.495 1.176-3.928 1.204 3.928 1.463 10.466a.554.554 0 00.257.4.576.576 0 00.487.058l3.528-1.118a.587.587 0 00.4-.574l-.916-22.135v-.058l-.287-1.147a.582.582 0 00-.574-.487H8.978c-.287 0-.516.2-.573.486l-.287 1.147v.057L7 24.828c-.001.287.142.517.401.603zM19.645 3.323l.086 1.75a2.315 2.315 0 01-1.491-1.75h1.405zM13.766 6.39h.86V3.036h-.86v3.355zm-4.53-3.068h1.233c-.144.746-.631 1.376-1.29 1.663l.056-1.663z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgJeans;